import React, { useEffect, useState } from 'react';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';
import { CollectionOrderFilters } from '../../../../app/models/CollectionOrder';
import useProjectService from '../../../../app/services/hooks/useProjectService';

interface Props {
  filter: CollectionOrderFilters;
  setFilter: (filter: CollectionOrderFilters) => void;
  onSearch: () => void;
}

const CollectionOrderFilter = ({ filter, setFilter, onSearch }: Props) => {
  const { getProjects } = useProjectService();
  const [projectOptions, setProjectOptions] = useState<{ id: number; name: string }[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value
    });
  };

  useEffect(() => {
    // Cargar listado de proyectos una sola vez al montar el filtro
    getProjects(
      {
        page: 1,
        per_page: 100,
        sort: 'name',
        order: 'desc'
      } as any,
      {
        onSuccess: (response: any) => {
          setProjectOptions(response.data?.projects ?? []);
        }
      }
    );
  }, []); // usamos arreglo vacío para no depender de reglas de react-hooks

  const doSearch = () => {
    // Ejecuta la búsqueda actual con los filtros definidos
    onSearch();
  };

  return (
    <div className="row">
      <div className="row">
        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Proyecto</label>
            <select
              name="project"
              className="form-control form-control-sm"
              style={{ minWidth: 140 }}
              value={filter.project ?? ''}
              onChange={handleChange}
            >
              <option value="">Todos</option>
              {projectOptions.map((p) => (
                <option key={p.id} value={p.name}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Estado</label>
            <select
              name="status"
              className="form-control form-control-sm"
              value={filter.status ?? ''}
              onChange={handleChange}
            >
              <option value="">Todos</option>
              <option value="CREATED">Creado</option>
              <option value="IN_PROGRESS">En progreso</option>
              <option value="FINALIZED">Finalizado</option>
              <option value="ANNULLED">Anulado</option>
            </select>
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Prog. desde</label>
            <input
              type="date"
              name="program_date_from"
              className="form-control form-control-sm"
              value={filter.program_date_from ?? ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Prog. hasta</label>
            <input
              type="date"
              name="program_date_to"
              className="form-control form-control-sm"
              value={filter.program_date_to ?? ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Inicio desde</label>
            <input
              type="date"
              name="start_date_from"
              className="form-control form-control-sm"
              value={filter.start_date_from ?? ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Inicio hasta</label>
            <input
              type="date"
              name="start_date_to"
              className="form-control form-control-sm"
              value={filter.start_date_to ?? ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div style={{ marginTop: '22px' }}>
            <ButtonSearchFilter callbackSearch={doSearch} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollectionOrderFilter;

